import { FacebookIcon } from "@/components/icons/FacebookIcon";
import { InstagramIcon } from "@/components/icons/InstagramIcon";
import { LinkedinIcon } from "@/components/icons/LinkedinIcon";
import { TiktokIcon } from "@/components/icons/TiktokIcon";
import { cn } from "@/utils/general";
import { ThemeTypes } from "@/utils/theming";

import styles from "./BottomNavigationMobile.module.scss";

interface BottomNavigationMobileProps {
  theme?: ThemeTypes;
}

const BottomNavigationMobile = ({ theme = "master" }: BottomNavigationMobileProps) => {
  const isMen = theme === "men";
  return (
    <div
      className={cn(
        styles.menuBottom,
        isMen ? styles.menuBottomMen : styles.menuBottom,
        "md:mx-auto"
      )}
    >
      <div
        className={cn(
          isMen ? styles.menuMen : styles.menu,
          styles.socialMenu,
          "flex",
          "justify-around",
          "border",
          "rounded",
          "flex-1",
          "p-0"
        )}
      >
        <div className={cn(styles.menuItem, "w-full", "max-w-14")}>
          <a
            href="https://www.instagram.com/nutrafol/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram (Opens in new tab)"
            className="flex items-center justify-center h-14 mx-auto text-nova-base-black"
          >
            <InstagramIcon />
          </a>
        </div>

        <div className={cn(styles.menuItem, "w-full", "max-w-14")}>
          <a
            href="https://www.tiktok.com/@nutrafol"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Tiktok (Opens in new tab)"
            className="flex items-center justify-center h-14 mx-auto text-nova-base-black"
          >
            <TiktokIcon />
          </a>
        </div>

        <div className={cn(styles.menuItem, "w-full", "max-w-14")}>
          <a
            href="https://www.facebook.com/nutrafol/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook (Opens in new tab)"
            className="flex items-center justify-center h-14 mx-auto text-nova-base-black"
          >
            <FacebookIcon />
          </a>
        </div>

        <div className={cn(styles.menuItem, "w-full", "max-w-14")}>
          <a
            href="https://www.linkedin.com/company/nutrafol/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Linkedin (Opens in new tab)"
            className="flex items-center justify-center h-14 mx-auto text-nova-base-black"
          >
            <LinkedinIcon />
          </a>
        </div>
      </div>
    </div>
  );
};

export default BottomNavigationMobile;
